import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";

import { useAdvancedViewFiltersStore } from "data/store/global-search/AdvancedViewFiltersStore";
import { GlobalSearchSelectOption } from "data/@types/GlobalSearchData";

export const BooleanFilter = ({
  name,
  activityType,
}: {
  name: string;
  activityType: GlobalSearchSelectOption;
}) => {
  const activeFilters = useAdvancedViewFiltersStore(
    (state) => state.filtersByActivity[activityType] || {},
  );
  const setActiveFilters = useAdvancedViewFiltersStore(
    (state) => state.setFiltersForActivity,
  );

  const booleanValue = activeFilters[name]?.valueText || "any";

  const handleChange = (event: SelectChangeEvent) => {
    setActiveFilters(activityType, {
      ...activeFilters,
      [name]: {
        ...activeFilters[name],
        valueText: event.target.value || "any",
      },
    });
  };

  return (
    <Box sx={{ marginLeft: "3.2rem" }}>
      <FormControl fullWidth sx={{ margin: ".4rem" }}>
        <InputLabel id={name}>Is</InputLabel>
        <Select
          sx={{
            width: "50%",
          }}
          id={name}
          data-test-id={name}
          labelId={name}
          size="small"
          value={
            Array.isArray(booleanValue)
              ? booleanValue.join(",")
              : booleanValue || ""
          }
          label="Is"
          onChange={handleChange}
        >
          {["any", "true", "false"].map((value) => (
            <MenuItem key={value} value={value}>
              {value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
